// extracted by mini-css-extract-plugin
export default {"imgObjectCover":"StoreBestOffers-module--imgObjectCover--CoIIh","OffersSizing":"StoreBestOffers-module--OffersSizing--dXXo9"};